// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
.checkbox-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.checkbox-container .checkbox {
  padding-right: 18px;
}
.checkbox-container .line {
  border-right: 2px solid #9dbcda;
  margin-right: 10px;
  height: 18px;
}

.via-station-validation {
  margin: 20px 0;
}

.announcement-history-container {
  margin-top: 10px;
  list-style-type: disc;
}
.announcement-history-container li {
  margin-left: 30px;
  width: 90%;
}
.announcement-history-container span {
  font-size: 14px;
  margin-right: 5px;
}
.announcement-history-container span:last-of-type {
  margin-right: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
